module.exports = __webpack_public_path__ + "img/hilo-up.1b2ccaf6.png";